export default __webpack_public_path__ + "static/media/video.56521886.svg";